// src/components/features/PreActivitySelector/activitySequenceApi.js
import { apiClient } from '../../../../services/apiClient';


export const activitySequenceApi = {
  // Fetch list of object types
  getObjectTypes: async () => {
    const response = await apiClient.get('/object-types');
    const data = response.data;
    if (Array.isArray(data.objectTypes)) return data.objectTypes;
    if (Array.isArray(data)) return data;
    throw new Error('Invalid object types response format');
  },

  // Fetch activities for a given object type
  getActivitiesForObjectType: async (objectType) => {
    if (!objectType) throw new Error('Object type is required');
    // Backend returns a map under `objectTypeActivities` for all object types
    const response = await apiClient.get('/object-type-activities');
    const data = response.data;
    const map = data?.objectTypeActivities || data;
    if (map && Array.isArray(map[objectType])) return map[objectType];
    throw new Error('Invalid activities response format');
  },

  // Save activity sequence (supports parallel and partial)
  saveSequence: async (objectType, sequence) => {
    if (!objectType) throw new Error('Object type is required');
    if (!Array.isArray(sequence)) throw new Error('Sequence must be an array');
    const response = await apiClient.post('/save-sequence', {
      object_type: objectType,
      sequence,
    });
    return response.data; // { object_type, sequence, sequenceDict, stepCount }
  },
};
